import React from 'react';

import * as styles from './cookie-consent-banner-link.module.scss';

export const CookieConsentBannerLink: React.FC<{ text: string; onClick: () => void }> = ({
  onClick,
  text,
}) => (
  <div className={styles.link} onClick={onClick}>
    {text}
  </div>
);
